import {observable, computed} from 'mobx';
import {IClient} from '@techsee/techsee-chat-api/lib/contract/contractChatApi';
import {MeetingMode} from '@techsee/techsee-common/lib/constants/room.constants';
import {WifiScanStatusType, VisualScanStatusType} from '@techsee/techsee-common/lib/constants/utils.constant';
import {IContainerPoint} from '@techsee/techsee-common/lib/constants/canvas-drawer.constant';

/**
 * Simple observable state container that mirrors ChatApi's client.
 */
export class ClientRoomStorage implements IClient {
    // Properties that match IClient interface from contractChatApi
    @observable enableHistory: boolean = false;
    @observable firstConnected: boolean = false;
    @observable connected: boolean = false;
    @observable videoSupport?: boolean = undefined;
    @observable audioSupport?: boolean = undefined;
    @observable visualScanStatus: VisualScanStatusType = VisualScanStatusType.NotInitialized;
    @observable photoSupport: boolean = true;
    @observable deviceInfo?: string = undefined;
    @observable mode: any = MeetingMode.video;
    @observable availableModes: string[] = [];
    @observable preparing: boolean = true;
    @observable audioMuted: boolean = false;
    @observable rejectedStreams: any[] = [];
    @observable location: boolean = false;
    @observable tosAccepted: boolean = false;
    @observable tosRejected: boolean = false;
    @observable pausedBy?: boolean | any = undefined;
    @observable _isReviewingTOS: boolean = false;
    @observable isViewingPermissionsModal: boolean = false;
    @observable isReviewingVideoApplicationCameraAudioDialog: boolean = false;
    @observable inCameraApprovalDialog: boolean = false;
    @observable isOnPreCameraApprovalScreen: boolean = false;
    @observable isPreCameraApprovedByUser: boolean = false;
    @observable isOnScreenShareCapturingPermission: boolean = false;
    @observable screenShareCapturingApprovedIOS: boolean = false;
    @observable isOnscreenShareTurnOffGuidanceIOS: boolean = false;
    @observable photoSelectionDialogState?: string = undefined;
    @observable clientType?: boolean = undefined;
    @observable clientOs?: string = undefined;
    @observable clientOsObject: {name?: string; version?: string} = {name: undefined, version: undefined};
    @observable clientDeviceBrowser?: string = undefined;
    @observable clientDevice?: string = undefined;
    @observable showPhotoTakingGuidance: boolean = true;
    @observable viewRectangle: {height: number; width: number} = {
        height: 0,
        width: 0
    };
    @observable videoHandshakeSuccess: boolean = false;
    @observable imageUploadHandshakeSuccess: boolean = false;
    @observable oneClickHandshakeSuccess: boolean = false;
    @observable screenHandshakeSuccess: boolean = false;
    @observable coBrowsingHandshakeSuccess: boolean = false;
    @observable appSharingHandshakeSuccess: boolean = false;
    @observable videoApplicationHandshakeSuccess: boolean = false;
    @observable faceMeetHandshakeSuccess: boolean = false;
    @observable visible: boolean = true;
    @observable focused: boolean = true;
    @observable mediaServiceType?: string = undefined;
    @observable drawings: IContainerPoint[] = [];
    @observable speedtestResults?: any = undefined;
    @observable usingApplication: boolean = false;
    @observable flowType?: string = undefined;
    @observable audioHandshakeSuccess: boolean | null = null;
    @observable livePointerUnavailable?: boolean = undefined;
    @observable mediaPermissionsAccepted: boolean = false;
    @observable mediaPermissionsRejected: boolean = false;
    @observable webRtcSupported?: boolean = undefined;
    @observable agentHasRemoteControl?: boolean = false;
    @observable videoPaused?: boolean = undefined;
    @observable meeting?: boolean = undefined;
    @observable initiateWithVideo?: boolean = undefined;
    @observable initiateWithAudio?: boolean = undefined;
    @observable zoomCapability: {supported: boolean; min?: number; max?: number; step?: number} | null = null;
    @observable zoomLevel: number = 1;

    // Additional properties that were in the original class but not in IClient interface
    @observable clickOnDesktopShare: boolean = false;
    @observable isFullScreen: boolean = false;
    @observable reloadWhenVideoFailed: boolean = false;
    @observable wifiScanStatus = WifiScanStatusType.NotInitialized;

    @computed
    get isReviewingTOS(): boolean {
        return this._isReviewingTOS && !this.tosAccepted && !this.tosRejected;
    }
}
